import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  path: string;
  jsonLd?: object[];
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function Seo({ title, description, path, jsonLd = [] }: SeoProps) {
  useEffect(() => {
    const baseUrl = 'https://mangpush.github.io';
    const canonical = `${baseUrl}${path}`;

    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', '漫画,漫画更新提醒,漫画追更工具,漫画最新话推送,漫画连载进度查询,漫画更新日历,漫画追更社区');

    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', '漫迹 MangaTrack');
    setMeta('property', 'og:locale', 'zh_CN');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    // 清理旧的 JSON-LD
    document.querySelectorAll('script[data-seo-jsonld]').forEach((s) => s.remove());
    jsonLd.forEach((obj) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-seo-jsonld', '1');
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });

    return () => {
      document.querySelectorAll('script[data-seo-jsonld]').forEach((s) => s.remove());
    };
  }, [title, description, path, JSON.stringify(jsonLd)]);

  return null;
}

export const siteSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '漫迹 MangaTrack',
  url: 'https://mangpush.github.io',
  logo: 'https://mangpush.github.io/logo.png',
  description: '专业的漫画追更工具，提供漫画更新提醒、最新话推送、连载进度查询与漫画追更社区。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hi@mangatrack.cn',
    contactType: 'customer service',
    areaServed: 'CN',
    availableLanguage: 'zh-CN',
  },
};

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '漫迹 MangaTrack',
  url: 'https://mangpush.github.io',
  description: '漫画追更工具官网，支持漫画更新提醒、最新话推送与连载进度查询。',
};